import addRoute from '@/router/add-route';

const CustomerForm = () => import('@/modules/customers/customer-form.vue');
const CustomerDetails = () => import('@/modules/customers/customer-details.vue');

const customers = [
    addRoute({
        name: 'customers',
        path: '/customers',
        redirect: '/lists/read-only-customers',
    }),
    addRoute({
        name: 'add-customer',
        path: '/customer/add',
        component: CustomerForm,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'customer-details',
        path: '/customers/:id/:segmentId?',
        component: CustomerDetails,
        root: {label: 'Lists', name: 'lists'},
    }),
];

export default customers;
